import CityIcon from './component'

export default CityIcon
